import React, { useContext, useEffect } from 'react';
import { FE_VERSION } from 'utils';
import { I18N, I18NContext, GlobalContext } from 'commons';
import styled from 'styled-components';
import v from 'scss/v';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowRestore } from '@fortawesome/free-solid-svg-icons';

const Container = styled.footer`
  background: ${v('$body-color')};
  padding: 1.25rem 0;
  margin-top: 2.5rem;
  color: ${v('$global-white')};

  a {
    color: ${v('$global-white')};
    padding: 0 0.3125rem;
    text-decoration: underline;
  }

  a:hover {
    color: ${v('$blue-1')};
  }

  p {
    margin: 0 0 0.5rem;
    &.text-muted {
      color: ${v('$text-muted')} !important;
    }
  }

  @media only screen and (max-width: ${v('$small-screen')}px) {
    margin-top: 0;
  }
`;

const Footer = () => {
  const { server = {} } = useContext(GlobalContext) || {};
  const { version, serverName } = server;
  const i18n = React.useContext(I18NContext);

  return (
    <Container role="contentinfo" aria-label={i18n['member.portal.footer.title']} data-nosnippet>
      <div className="text-center">
        <p>
          <span>
            <I18N>member.portal.footer.poweredby</I18N>&nbsp;
            <img src="/public/images/EVE_Horizontal_Logo_White.svg" alt="Everbridge" height="21" />
            &nbsp;
          </span>
          <a
            href="https://www.everbridge.com/about/legal/everbridge-terms-of-use/"
            rel="noopener noreferrer nofollow"
            target="_blank"
          >
            <I18N>ssp.footer.info2</I18N>&nbsp;<FontAwesomeIcon
              icon={faWindowRestore}
              width="1.275em"
              height="1.275em"
            />
            <span className="sr-only"><I18N>member.portal.footer.new.window</I18N></span>
          </a>
            &nbsp;
          <a
            href="https://www.everbridge.com/about/legal/everbridge-global-privacy-notice/"
            rel="noopener noreferrer nofollow"
            target="_blank"
          >
            <I18N>member.portal.footer.privacy.policy</I18N>&nbsp;<FontAwesomeIcon
              icon={faWindowRestore}
              width="1.275em"
              height="1.275em"
            />
            <span className="sr-only"><I18N>member.portal.footer.new.window</I18N></span>
          </a>
        </p>
        <p className="text-muted text-terms">
          <I18N>member.portal.footer.changes</I18N>
        </p>
        <p className="text-muted">
          <span id="copyright">&copy; {new Date().getFullYear()} Everbridge, Inc.</span>
            &nbsp;
          <span>{version}</span>
            &nbsp;
          <span>FE-VERSION:&nbsp;{FE_VERSION}</span>
            &nbsp;
          <span>{serverName}</span>
        </p>
      </div>
    </Container>
  );
};

export default Footer;
